import { render, staticRenderFns } from "./template-add-or-update.vue?vue&type=template&id=6fbe6376"
import script from "./template-add-or-update.vue?vue&type=script&lang=js"
export * from "./template-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports